<template>
  <div
    v-bind:style="showModal ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-info modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Registro horario :: {{day | formatDate}} [{{truck.plate}}]</h4>
          <button @click="close" class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body"> 
          <h5>Factor: {{factor}}</h5>
          <div class="form-group">
            <textarea class="form-control" :required="factor < 1" :disabled="factor == 1"></textarea>
          </div>

          <ul class="list-group" v-if="assistance && assistance.hours.length">
            <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(hour,h) in assistance.hours" :key="h">
              {{hour.hour}}&nbsp;&nbsp;
              <select class="form-control" v-model="hour.code">
                <option value="">Seleccione item</option>
                <option v-for="(item, key) in items" :key="key" :value="item.code">{{item.name}}</option>
              </select>
            </li>
          </ul>

        </div>
        <div class="modal-footer">
          <template>
          <button class="btn btn-primary" @click="send">Registrar</button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ModalHours',
  props: ['showModal', 'day', 'assistance', 'truck'],
  data(){
    return {
      items: [
        { code: 'X', name: 'Operativo en puerto' },
        { code: 'I', name: 'En Inland' },
        { code: '0', name: 'Ausente' },
        { code: 'C', name: 'Cancelado' },
        { code: 'L', name: 'Logiminsa' },
      ]
    }
  },
  computed:{
    factor(){
      let sum = 0
      if(this.assistance){
        this.assistance.hours.map(hour => {
          if(hour.code !== '0' && hour.code !== ''){
            sum++
          }
        })
        return (sum/24).toFixed(1)
      } else {
        return sum
      }
    }
  },
  methods: {
    close() {
      // this.dataTest.reason = ''
      this.$emit("close");
    },
    send(){
      this.$emit("saveAssistance", this.assistance, this.factor)
    }
  }
}
</script>
